import { render, staticRenderFns } from "./airClean.vue?vue&type=template&id=1d913c32&scoped=true"
import script from "./airClean.vue?vue&type=script&lang=js"
export * from "./airClean.vue?vue&type=script&lang=js"
import style0 from "./airClean.vue?vue&type=style&index=0&id=1d913c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d913c32",
  null
  
)

export default component.exports